export const home = {
  nav: {
    about: 'About',
    reviews: 'Reviews',
    methodology: 'Methodology',
    faq: 'FAQ'
  },
  hero: {
    title: 'Best Prop Trading Firms Comparison in 2026',
    subtitle: 'Honest reviews and independent comparison',
    cta: 'Explore Reviews'
  },
  intro: {
    label: 'Understanding Prop Trading',
    title: 'What Are Proprietary Trading Firms',
    description: 'Proprietary trading firms, or prop firms, provide traders with capital to trade financial markets. Instead of risking your own money, you trade the firm\'s capital and share the profits. Most prop firms require traders to pass an evaluation or challenge phase before receiving a funded account. This model allows skilled traders to access larger capital while the firm manages the risk.',
    how1: 'Pass Evaluation',
    how1desc: 'Complete a trading challenge following specific rules and profit targets',
    how2: 'Get Funded',
    how2desc: 'Receive a funded account with the firm\'s capital to trade',
    how3: 'Share Profits',
    how3desc: 'Keep a percentage of profits generated from your trading activity'
  },
  about: {
    mission: 'Our mission is to provide neutral, transparent, and comprehensive reviews of proprietary trading firms. We are committed to helping traders make informed decisions by offering honest evaluations based on thorough research and analysis of each firm\'s offerings, rules, and reputation.',
    commitment1: 'No exaggerated claims or misleading information',
    commitment2: 'Transparent methodology and evaluation criteria',
    commitment3: 'Independent reviews with no bias toward any firm',
    commitment4: 'Educational content to help traders understand prop firm models',
    team: 'The PropFirm Review Team'
  },
  comparison: {
    title: 'Top Proprietary Trading Firms Compared',
    subtitle: 'Detailed analysis and honest ratings',
    accountSizes: 'Account Sizes',
    profitSplit: 'Profit Split',
    challenge: 'Challenge Rules',
    drawdown: 'Drawdown Limits',
    fees: 'Fees',
    payout: 'Payout Methods',
    pros: 'Pros',
    cons: 'Cons',
    viewDetails: 'View Details'
  },
  methodology: {
    title: 'How We Evaluate Prop Trading Firms',
    description: 'Our evaluation process is rigorous and transparent. We analyze each firm based on multiple criteria to ensure our reviews are accurate and helpful for traders.',
    phase1: 'Research Phase',
    phase1desc: 'We conduct comprehensive research on each firm, analyzing their rules, terms, reputation, and trader feedback from multiple sources.',
    phase2: 'Analysis Process',
    phase2desc: 'Our team evaluates challenge difficulty, payout reliability, customer support quality, trading conditions, and overall value proposition.',
    phase3: 'Scoring System',
    phase3desc: 'We use a standardized scoring system based on multiple criteria including rules fairness, payout speed, fees, platform quality, and trader satisfaction.'
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'What is a proprietary trading firm',
    a1: 'A proprietary trading firm provides capital to traders who pass their evaluation process. Traders use the firm\'s money to trade financial markets and share the profits with the firm. This allows traders to access larger capital without risking their own funds.',
    q2: 'How do prop firm challenges work',
    a2: 'Most prop firms require traders to pass a challenge or evaluation phase. This typically involves meeting profit targets while following specific rules such as maximum daily loss limits and overall drawdown limits. Once you pass, you receive a funded account.',
    q3: 'Are your reviews biased',
    a3: 'No. We maintain complete independence in our reviews. While we may earn affiliate commissions, this does not influence our ratings or recommendations. We provide honest evaluations based solely on our research and analysis.',
    q4: 'How often do you update your reviews',
    a4: 'We regularly update our reviews to reflect rule changes, new offerings, and changes in firm reputation. Major reviews are updated quarterly, while minor updates occur as needed when significant changes happen.',
    q5: 'Do you guarantee profits with these firms',
    a5: 'No. We do not guarantee any profits or trading success. Trading involves substantial risk, and most traders lose money. Our reviews help you make informed decisions, but your success depends on your trading skills, discipline, and risk management.',
    q6: 'How do affiliate links work',
    a6: 'When you click on our affiliate links and sign up with a prop firm, we may earn a commission at no extra cost to you. This helps support our research efforts. Our affiliate relationships do not influence our honest reviews.',
    q7: 'What should I look for in a prop firm',
    a7: 'Key factors include fair challenge rules, reasonable profit targets, transparent terms, reliable payouts, good customer support, competitive profit splits, and positive trader reviews. Always read the full terms and conditions before joining any firm.',
    q8: 'Are prop firms regulated',
    a8: 'Regulation varies by firm and jurisdiction. Some prop firms operate under financial regulations, while others operate as educational or technology companies. Always verify a firm\'s legal status and terms before participating.'
  },
  disclaimer: {
    title: 'Important Disclaimers',
    affiliate: 'Affiliate Disclosure',
    affiliateContent: 'This website contains affiliate links. When you click on these links and sign up with a prop firm, we may earn a commission at no additional cost to you. This helps support our research and content creation. Our affiliate relationships do not influence our reviews or ratings. We provide honest, unbiased evaluations based on our research and analysis.',
    risk: 'Trading Risk Disclaimer',
    riskContent: 'Trading financial instruments involves substantial risk and is not suitable for every investor. The high degree of leverage can work against you as well as for you. You should carefully consider your investment objectives, level of experience, and risk appetite before participating in prop firm challenges or funded accounts. There is a possibility that you could sustain a loss of some or all of your initial investment. You should not invest money that you cannot afford to lose. Past performance is not indicative of future results.',
    noGuarantee: 'No Guarantee Disclaimer',
    noGuaranteeContent: 'We do not guarantee any specific results, profits, or outcomes from using the prop firms we review. Success in trading depends on individual skills, discipline, market conditions, and various other factors. Most traders do not pass prop firm challenges. Always conduct your own research and due diligence before making any financial decisions.'
  },
  footer: {
    tagline: 'Providing honest and transparent proprietary trading firm reviews to help traders make informed decisions.',
    contact: 'Contact Information',
    quickLinks: 'Quick Links',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    cookies: 'Cookie Policy',
    contactUs: 'Contact Us',
    disclaimer: 'Risk Disclaimer'
  },
  firms: {
    ftmo: {
      description: 'One of the most established prop firms with a proven track record. FTMO offers a structured evaluation process and reliable payouts to successful traders.',
      accountSizes: '$10,000 - $200,000',
      profitSplit: '80% to trader (90% after 4 payouts)',
      challenge: 'Two-phase evaluation: 10% profit target in Phase 1, 5% in Phase 2',
      drawdown: '10% maximum daily loss, 10% maximum overall drawdown',
      fees: '$155 - $1,080 challenge fee (refunded on first payout)',
      payout: 'Bank transfer, cryptocurrency (14-day minimum)',
      pros: ['Established reputation', 'Reliable payouts', 'Comprehensive trading platform', 'Free trial available'],
      cons: ['Strict rules', 'Higher challenge fees', 'Two-phase evaluation required']
    },
    fundedtrading: {
      description: 'Offers flexible evaluation options with competitive profit splits. Known for trader-friendly rules and fast payout processing.',
      accountSizes: '$5,000 - $300,000',
      profitSplit: '80% to trader (up to 90% with scaling)',
      challenge: 'One or two-phase options: 8-10% profit targets',
      drawdown: '5% maximum daily loss, 10% maximum overall drawdown',
      fees: '$99 - $999 challenge fee (refundable)',
      payout: 'Bank transfer, PayPal, cryptocurrency (bi-weekly)',
      pros: ['Flexible evaluation options', 'Fast payouts', 'Scaling plan available', 'Lower fees'],
      cons: ['Newer firm', 'Limited track record', 'Stricter daily loss limits']
    },
    topstep: {
      description: 'Focused on futures trading with a well-established evaluation process. Offers comprehensive educational resources for traders.',
      accountSizes: '$50,000 - $150,000',
      profitSplit: '80% to trader (90% after consistency)',
      challenge: 'Combine evaluation: Meet profit target and consistency rules',
      drawdown: 'Trailing drawdown based on account balance',
      fees: '$165 - $375 monthly subscription',
      payout: 'Bank transfer (weekly or bi-weekly)',
      pros: ['Futures focused', 'Educational resources', 'Weekly payouts', 'Established reputation'],
      cons: ['Monthly subscription model', 'Futures only', 'Complex rules']
    },
    apex: {
      description: 'Offers both evaluation and direct funding options. Known for flexible rules and multiple account size choices.',
      accountSizes: '$25,000 - $300,000',
      profitSplit: '90% to trader',
      challenge: 'Rithmic evaluation or PA (Funded Account) options',
      drawdown: 'Trailing or static drawdown options',
      fees: '$147 - $297 evaluation fee',
      payout: 'Bank transfer, PayPal (on-demand after 10 days)',
      pros: ['High profit split', 'Flexible options', 'Multiple platforms', 'Fast payouts'],
      cons: ['Complex pricing structure', 'Rules vary by account type', 'Limited support']
    },
    myfundedfx: {
      description: 'Forex-focused prop firm with competitive evaluation terms. Offers rapid evaluation options for experienced traders.',
      accountSizes: '$5,000 - $200,000',
      profitSplit: '80% to trader',
      challenge: 'One or two-phase: 8% profit target in Phase 1',
      drawdown: '5% maximum daily loss, 10% maximum overall drawdown',
      fees: '$49 - $999 challenge fee',
      payout: 'Bank transfer, cryptocurrency (14-day minimum)',
      pros: ['Forex focused', 'Rapid evaluation option', 'Competitive fees', 'Crypto payouts'],
      cons: ['Strict daily loss limits', 'Limited asset classes', 'Newer firm']
    },
    the5ers: {
      description: 'Offers unique funding programs with immediate funding options. Known for flexible trading conditions and multiple program choices.',
      accountSizes: '$5,000 - $250,000',
      profitSplit: '50-80% to trader (varies by program)',
      challenge: 'Multiple programs: High Stakes, Bootcamp, Instant Funding',
      drawdown: 'Varies by program (4-6% daily, 8-10% overall)',
      fees: '$75 - $890 program fee',
      payout: 'Bank transfer, PayPal (monthly)',
      pros: ['Multiple program options', 'Instant funding available', 'Flexible rules', 'Scaling opportunities'],
      cons: ['Lower profit splits on some programs', 'Complex program structure', 'Monthly payout schedule']
    },
    fundednext: {
      description: 'Growing prop firm with competitive terms and multiple evaluation models. Offers both standard and express challenges.',
      accountSizes: '$6,000 - $200,000',
      profitSplit: '80-90% to trader',
      challenge: 'One or two-phase options: 10% profit target',
      drawdown: '5% maximum daily loss, 10% maximum overall drawdown',
      fees: '$49 - $999 challenge fee (refundable)',
      payout: 'Bank transfer, cryptocurrency (bi-weekly)',
      pros: ['Competitive profit splits', 'Express challenge option', 'Refundable fees', 'Growing reputation'],
      cons: ['Relatively new', 'Limited track record', 'Strict consistency rules']
    },
    trueforexfunds: {
      description: 'Offers straightforward evaluation process with transparent rules. Known for trader-friendly terms and reliable operations.',
      accountSizes: '$5,000 - $200,000',
      profitSplit: '80% to trader',
      challenge: 'Two-phase evaluation: 8% and 5% profit targets',
      drawdown: '5% maximum daily loss, 10% maximum overall drawdown',
      fees: '$99 - $999 challenge fee',
      payout: 'Bank transfer, cryptocurrency (14-day minimum)',
      pros: ['Transparent rules', 'Reasonable targets', 'Crypto payouts', 'Good support'],
      cons: ['Two-phase required', 'Standard profit split', 'Limited platforms']
    },
    e8funding: {
      description: 'Offers flexible evaluation options with competitive pricing. Known for fast evaluation process and multiple account types.',
      accountSizes: '$25,000 - $400,000',
      profitSplit: '80% to trader',
      challenge: 'One-phase evaluation: 8% profit target',
      drawdown: '5% maximum daily loss, 8% maximum overall drawdown',
      fees: '$99 - $999 challenge fee',
      payout: 'Bank transfer (bi-weekly)',
      pros: ['One-phase evaluation', 'Large account sizes', 'Fast process', 'Competitive fees'],
      cons: ['Stricter drawdown limits', 'Limited payout methods', 'Newer firm']
    },
    blueguardian: {
      description: 'Offers unique evaluation structure with focus on consistency. Known for educational approach and trader development.',
      accountSizes: '$25,000 - $200,000',
      profitSplit: '80% to trader',
      challenge: 'Consistency-focused evaluation with profit targets',
      drawdown: '4% maximum daily loss, 8% maximum overall drawdown',
      fees: '$125 - $799 challenge fee',
      payout: 'Bank transfer (monthly)',
      pros: ['Focus on consistency', 'Educational resources', 'Transparent rules', 'Good support'],
      cons: ['Strict daily loss limits', 'Monthly payouts only', 'Limited account sizes']
    }
  }
};